import { render, staticRenderFns } from "./DenouncedList.vue?vue&type=template&id=972d3432&scoped=true&"
import script from "./DenouncedList.vue?vue&type=script&lang=js&"
export * from "./DenouncedList.vue?vue&type=script&lang=js&"
import style0 from "./DenouncedList.vue?vue&type=style&index=0&id=972d3432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972d3432",
  null
  
)

export default component.exports